import type { RegisterCfdType } from '@vend/types/register'
import type * as Ably from 'ably'

import { clearAblyToken } from './localStorage'

// Ably reports token problems (expired, revoked, capability mismatch) with error
// codes in the 40140–40149 range (a rotated/revoked CFD Ably key lands here).
const isAblyTokenError = (code: number | undefined): boolean =>
  code !== undefined && code >= 40140 && code <= 40149

/**
 * Drops the cached Ably token and forces re-authorization whenever Ably rejects
 * the current token.
 *
 * @returns a function that detaches the listener.
 */
export const attachTokenRotationRecovery = (
  client: Ably.Realtime,
  type: RegisterCfdType,
  registerId: string
): (() => void) => {
  const onStateChange = (stateChange: Ably.ConnectionStateChange): void => {
    if (!isAblyTokenError(stateChange.reason?.code)) {
      return
    }

    clearAblyToken(type, registerId)
  }

  client.connection.on(onStateChange)

  return () => client.connection.off(onStateChange)
}
